import { useMemo } from 'react';

import type { TAdfoxContextData } from '../../types';
import type { TPParams } from '../../../../../types';
import { useSelector } from 'react-redux';
import { selectRegionId } from '../../../../../../../selectors/filters';
import { isAgentSelector } from '../../../../../../../selectors/userData/isAgentSelector';
import { selectedStationsSelector } from '../../../../../../../selectors/stations/selectedStationsSelector';
import { selectedRoadsSelector } from '../../../../../../../selectors/roads/selectedRoadsSelector';
import { getCalculatedParams, getRandomId, getJoinedUniqueIds } from '../utils';

type Params = TAdfoxContextData['params'];

export const PR_RANDOM = getRandomId();

export function useAdfoxParams(pParams: TPParams): Params {
  const regionId = useSelector(selectRegionId);
  const isAgent = useSelector(isAgentSelector);
  const selectedStations = useSelector(selectedStationsSelector);
  const selectedRoads = useSelector(selectedRoadsSelector);

  return useMemo((): Record<string, string> => {
    return {
      ...pParams,
      ...getCalculatedParams(),
      pr: PR_RANDOM,
      puid1: 'deal_type_sale',
      puid10: isAgent ? 'agent' : 'no_agent',
      puid2: 'offer_suburban',
      puid3: 'sale_type_first',
      puid5: `obl_id_${regionId}`,
      puid34: getJoinedUniqueIds(selectedStations),
      puid35: getJoinedUniqueIds(selectedRoads),
    };
  }, [isAgent, pParams, regionId, selectedRoads, selectedStations]);
}
